import { useContext, useEffect } from 'react';
import { scrollToAlert } from '@lib/utils';
import { PageContext } from '@lib/contexts/pageContext';

function useErrorHandling({
  errors,
  isSubmitting,
  wasSubmitting,
  setWasSubmitting,
  scrolling = true,
  modalContext = null,
}) {
  let { setPageMessage, setPageErrorMessage } = useContext(PageContext);
  if (modalContext) {
    // If the form is contained in a modal, then we need to use different message handlers, hence the override
    ({ setPageMessage, setPageErrorMessage } = modalContext);
  }

  /** ERROR HANDLING **/
  useEffect(() => {
    // Calculate the error messages to show at the top of the form
    const errorValues = Object.values(errors);
    const [missingRequired, otherErrors] = errorValues.reduce((acc, error) => {
      let flattenedErrors = [];
      if (error.type) {
        flattenedErrors = [error];
      } else {
        // nested error message, from some forms like Event Demographics with grouped fields
        flattenedErrors = Object.values(error);
      }
      flattenedErrors.forEach((e) => {
        if (e.type === 'required') {
          acc[0] = true;
        } else {
          if (!acc[1].includes(e.message)) {
            acc[1].push(e.message);
          }
        }
      });
      return acc;
    }, [false, []]);

    // Here tracks if the form was submitted on the last render (meaning submit was clicked and validation is occurring)
    if (isSubmitting) {
      setWasSubmitting(true);
    } else if (wasSubmitting) {
      setWasSubmitting(false);
    }

    if (missingRequired || !!otherErrors.length) {
      // Only show the alert if the form was actually submitted via the button
      if (wasSubmitting) {
        const messages = [];
        if (missingRequired) {
          messages.push('Please fill out all required (*) fields.');
        }
        if (!!otherErrors.length) {
          messages.push(...otherErrors)
        }
        if (messages.length) {
          setPageMessage(null);
          setPageErrorMessage(messages);
        }
        if (scrolling) {
          scrollToAlert();
        }
      }
    } else {
      // setPageErrorMessage(null);
    }
  }, [errors, isSubmitting, scrolling, setPageErrorMessage, setPageMessage, setWasSubmitting, wasSubmitting]);
}

export default useErrorHandling;
